'use client'

import { Box, Text, VStack } from '@chakra-ui/react'
import Image, { StaticImageData } from 'next/image'
import React from 'react'

import CertificationImage from '@images/brands/cheongdam/certification.png'

import KI1 from '@images/brands/cheongdam/ki1.png'
import KI2 from '@images/brands/cheongdam/ki2.png'
import KI3 from '@images/brands/cheongdam/ki3.png'
import KI4 from '@images/brands/cheongdam/ki4.png'

const certificationData = [
  {
    isRight: true,
    image: KI1,
    title: '7 Peptides',
    text: '(Acetyl Hexapeptide-8, Copper Tripeptide-1,Palmitoyl Pentapeptide-4, Tripeptide-1, PalmitoylTripeptide-1, Hexapeptide-9, Nonapeptide-1)'
  },
  {
    isRight: false,
    image: KI2,
    title: '5 Ceramides',
    text: '(Ceramide EOP, Ceramide NS, Ceramide NP,Ceramide AS, Ceramide AP)'
  },
  {
    isRight: true,
    image: KI3,
    title: '8 Hyaluronic Acids',
    text: '(Sodium Hyaluronate, Hydrolyzed Hyaluronic Acid, Sodium Acetylated Hyaluronate, Hydroxypropyltrimonium Hyaluronate, Hyaluronic Acid, Sodium Hyaluronate Crosspolymer, Potassium Hyaluronate, Hydrolyzed Sodium Hyaluronate)'
  },
  {
    isRight: false,
    image: KI4,
    title: '4 Vegetable Oils',
    text: '(Avocado Oil, Evening Primrose Oil, Hippophae Rhamnoides Oil, Argania Spinosa Kernel Oil)'
  }
]

const CertificationItem = ({
  image,
  title,
  text,
  isRight
}: {
  image: StaticImageData
  title: string
  text: string
  isRight: boolean
}) => {
  return (
    <VStack
      data-aos="fade-up"
      position={'relative'}
      alignItems={isRight ? 'end' : 'start'}
      maxW={'100%'}
      justifyContent={'center'}
      h={'100%'}
    >
      <Image src={image} width={550} height={150} alt={title} />
      <VStack
        position={'absolute'}
        w={'50%'}
        px={2}
        gap={{
          base: 0,
          md: 2
        }}
      >
        <Text
          width="100%"
          textStyle={'certificationTitle'}
          textAlign={isRight ? 'left' : 'right'}
        >
          {title}
        </Text>
        <Text
          textStyle={'certificationText'}
          color={'doveGray'}
          textAlign={isRight ? 'left' : 'right'}
        >
          {text}
        </Text>
      </VStack>
    </VStack>
  )
}

const CertificationIntroduction = () => {
  return (
    <Box
      data-aos="fade-up"
      width={{
        sm: 470,
        base: 320
      }}
      height={{
        sm: 850,
        base: 500
      }}
      position="relative"
    >
      <Box
        position="absolute"
        zIndex={1}
        textAlign="center"
        top={{
          sm: '53px',
          base: '30px'
        }}
      >
        <Text
          color="white"
          fontSize={{
            sm: 26,
            base: 18
          }}
          fontWeight="bold"
          fontFamily="ITC"
        >
          Patented Key Ingredient
        </Text>
        <Text
          color="white"
          fontSize={{
            sm: 22,
            base: 14
          }}
          fontWeight="500"
          mt={{
            sm: '12px',
            base: '2px'
          }}
          fontFamily="ITC"
        >
          Extracts from Plants Roots, etc.
        </Text>
        <Text
          color="#ccad6a"
          fontSize={{
            sm: 22,
            base: 14
          }}
          fontWeight="bold"
          mt={{
            sm: '10px',
            base: '6px'
          }}
          fontFamily="ITC"
        >
          22 patented key ingredients
        </Text>
        <Text
          color="white"
          px={{
            md: '8',
            base: 2
          }}
          mt={{
            md: 3,
            sm: 2,
            base: 1
          }}
          fontSize={{ sm: '9px', base: '6px' }}
        >
          Paeonia Lactiflora Root Extract, Glycyrrhiza Glabra (Licorice) root
          Extract, Polygonum Multiflorum Root Extract, Phellinus Linteus
          Extract, Morus Alba Bark Extract, Sophora Flavescens Rott Extract,
          Cimicifuga Racemosa Root Extract, Sesamum Indicum (Sesame) Seed
          Extract, Angelica Gigas Root Extract, Scutellaria Baicalensis Root
          Extract, Centella Asiatica Extract, Polygonum Cuspidatum Root Extract,
          Camellia Sinensis (Green Tea) Leaf Extract, Chamomilla Recutita
          (Matricaria) Flower Extract, Rosmarinus Officinalis (Rosemary) Leaf
          Extract, Diospyros Kaki Fruit Extract, Camellia Japonica Leaf Extract,
          Ceratonia Siliqua (Carob) Fruit Extract, Oenothera Biennis (Evening
          Primrose) Flower Extract, Pueraria Lobata Root Extract, Pueraria
          Lobata Root Extract, Pinus Palustris Leaf Extract, Ulmus Davidiana
          Root Extract.
        </Text>
      </Box>
      <Image src={CertificationImage} fill alt="boder-black" />
    </Box>
  )
}

const Certification = () => {
  return (
    <VStack my={10}>
      <CertificationIntroduction />
      <VStack>
        {certificationData.map((item, index) => (
          <CertificationItem
            key={index}
            isRight={item.isRight}
            image={item.image}
            title={item.title}
            text={item.text}
          />
        ))}
      </VStack>
    </VStack>
  )
}

export default Certification
